import React from 'react';

class Slide4 extends React.Component {
    constructor(props) {
        super(props);
        this.slide4 = React.createRef();
        this.handleScroll = this.handleScroll.bind(this);
        this.rangePopUpChangeHandler = this.rangePopUpChangeHandler.bind(this);
        this.rangePopUpInputHandler = this.rangePopUpInputHandler.bind(this);
        this.rangePopUpClickHandler = this.rangePopUpClickHandler.bind(this);
        this.ctaButtonHandler = this.ctaButtonHandler.bind(this);
        this.destroyExistingSliderIfExists = this.destroyExistingSliderIfExists.bind(this);
        this.minSavingsValue = 2000;
        this.currencyFormat = wNumb({
            decimals: 0,
            thousand: ' ',
            prefix: 'R'
        });
        this.state = {
            step: 500,
            visible: false,
            scrolling: false,
            graphData: {},
            popContent: `<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span>
            <p class='font-size-18 fw-bold text-white mt-0'></p>`,
            collapseOpen: false,
            vestedSliderValue: 0,
            savingsSliderValue: 0,
            savingsAboveMinState: true,
            maxPotentialTaxValue: 0
        };
    }
    componentDidMount() {
        this.props.custScrollTo(this.slide4.current)

        // init vested slider
        if (this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment > 0) {
            let slider = document.getElementById('slider-round');

            $('[data-toggle="popover"]').popover();
            $(".fade").addClass("in");
            $(document).on("click", ".popover .slide3__popover-cancel", function () {
                $(this).parents(".popover").popover('hide');
            });



            const rangeSetup = {}
            rangeSetup['min'] = [0, 1];
            rangeSetup['max'] = this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment;

            
            this.destroyExistingSliderIfExists(slider);
            noUiSlider.create(slider, {
                start: 0,
                connect: [true, false],
                range: rangeSetup
            });
            slider.noUiSlider.on('update', (values, handle, unencoded, tap, positions, noUiSlider) => this.setValue(values, positions));
            slider.noUiSlider.on('change', () => {
                gtag('event', 'Slider - Moved', {
                    'event_category': 'Preservation calculator',
                    'event_label': 'Vested Slider - Adjust the slider',
                });
            });
        }


        // init savings slider
        if (this.props.formData.savingsInvestment > 0 || this.props.formData.formattedSavingsInvestment !== '') {
            let sliderSavings = document.getElementById('slider-round-savings');

            // need to convert the actual savings value to 1 if it's 0 for slider to not be (rightfully) weird
            let savingsInvestmentNonZeroValue = this.props.formData.savingsInvestment > 0 ? this.props.formData.savingsInvestment : 1;

            const rangeSetupSavings = {}

            // savings amount equal or more than min (R2000) 
            let savingsAboveMin = this.props.formData.savingsInvestment >= this.minSavingsValue;


            // if have withdrawn in current tax year
            if (this.props.formData.withdrawalYear === 1) {
                rangeSetupSavings['min'] = [0, 1];
                rangeSetupSavings['max'] = savingsInvestmentNonZeroValue;

                // if savings below than min, withdraw all or nothing
                if(!savingsAboveMin){                    
                    rangeSetupSavings['min'] = [0, savingsInvestmentNonZeroValue];

                    // if savings is 0, disable slider
                    if(this.props.formData.savingsInvestment === 0){
                        sliderSavings.closest('.slider-styled-wrap').classList.add('is-disabled');
                    }
                }
                

                // if savings above min, disable slider
                if (savingsAboveMin) {                    
                    sliderSavings.closest('.slider-styled-wrap').classList.add('is-disabled');
                }
            }

            // if have not withdrawn this tax year
            if (this.props.formData.withdrawalYear === 0) {
                

                // if savings above min, first step starts at min (R2000)
                if (savingsAboveMin) {                    
                    let minRangeStepPercent = (this.minSavingsValue / savingsInvestmentNonZeroValue * 100) + '%';
                    rangeSetupSavings['min'] = [0, this.minSavingsValue];
                    rangeSetupSavings[minRangeStepPercent] = [this.minSavingsValue, 1];   
                    rangeSetupSavings['max'] = savingsInvestmentNonZeroValue;                 
                }

                // if savings below min, disable slider
                if (!savingsAboveMin) {                    
                    rangeSetupSavings['min'] = [0, savingsInvestmentNonZeroValue];   
                    rangeSetupSavings['max'] = savingsInvestmentNonZeroValue;                 
                    sliderSavings.closest('.slider-styled-wrap').classList.add('is-disabled');
                }

            }

           

            // attach popovers
            this.setState({ savingsAboveMinState: savingsAboveMin }, () => {
                $('[data-toggle="popover"]').popover();
            });

                
            this.destroyExistingSliderIfExists(sliderSavings);
            noUiSlider.create(sliderSavings, {
                start: 0,
                connect: [true, false],
                range: rangeSetupSavings
            });


            sliderSavings.noUiSlider.on('update', (values, handle, unencoded, tap, positions, noUiSlider) => {
                this.setSavingsValue(values, positions)
            });


            sliderSavings.noUiSlider.on('change', (values) => {
                gtag('event', 'Slider - Moved', {
                    'event_category': 'Preservation calculator',
                    'event_label': 'Savings Slider - Adjust the slider',
                });
            });
        }



        // on scroll
        window.addEventListener('scroll', this.handleScroll);
        this.handleMaxTax()
    }

    componentWillUnmount() {
        let slider = document.getElementById('slider-round');
        let sliderSavings = document.getElementById('slider-round-savings');
        if (slider) slider.noUiSlider.off();
        if (sliderSavings) sliderSavings.noUiSlider.off();
        window.removeEventListener('scroll', this.handleScroll);
    }

    destroyExistingSliderIfExists(slider){
        if(slider && slider.noUiSlider){
            slider.noUiSlider.destroy();
        }
    }

    rangePopUpClickHandler(e) {
        e.target.querySelector('input') && e.target.querySelector('input').focus();
    }

    rangePopUpChangeHandler(e, sliderId) {
        let slider = document.getElementById(sliderId);
        const inputValue = this.currencyFormat.from(e.target.value);
        slider.noUiSlider.set(inputValue);
    }

    rangePopUpInputHandler(e) {
        // get start custor pos
        const startCursorPos = e.target.selectionStart
        const startLength = e.target.value.length;

        // formatting
        const inputValue = this.currencyFormat.from(e.target.value);
        const formattedVal = inputValue ? this.currencyFormat.to(inputValue) : 'R0';
        e.target.value = formattedVal;

        // set final cursor pos
        const endLength = formattedVal.length;
        const newCursorPos = endLength - startLength + startCursorPos;
        e.target.selectionStart = newCursorPos;
        e.target.selectionEnd = newCursorPos;
    }


    attachRangePopUp(id, value, position, text, sliderId) {
        let rangeV = document.getElementById(id);
        rangeV.innerHTML = ''; // clear it first to prevent blur issue, see: https://stackoverflow.com/questions/21926083/failed-to-execute-removechild-on-node
        rangeV.innerHTML = `<span>
                                ${text}
                                <br/>
                                <input 
                                    type="text" 
                                    autocomplete="off"
                                    spellcheck="false"
                                    value="${this.currencyFormat.to(value)}"
                                    class="noUISliderPopUpInput"                                    
                                />
                            </span>`;
        rangeV.style.left = `calc(${position}% + 2px)`;
        rangeV.addEventListener('click', this.rangePopUpClickHandler);
        rangeV.querySelector('input').addEventListener('change', (e) => this.rangePopUpChangeHandler(e, sliderId), false);
        rangeV.querySelector('input').addEventListener('blur', (e) => this.rangePopUpChangeHandler(e, sliderId), false);
        rangeV.querySelector('input').addEventListener('input', this.rangePopUpInputHandler, false);

    }

    setValue(values, rawPosition) {
        let value = this.currencyFormat.from(values[0]);
        let position = rawPosition[0];

        this.attachRangePopUp('rangeV', value, position, this.props.data?.slide4?.rangeText, 'slider-round');

        this.setState({ vestedSliderValue: value });

        this.calcHeight(value, this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment - value,
            this.state.savingsSliderValue, this.props.formData.savingsInvestment - this.state.savingsSliderValue)
    }

    setSavingsValue(values, rawPosition) {
        let value = this.currencyFormat.from(values[0]);
        let position = rawPosition[0];
        let label = this.props.journey === 1 ? this.props.data?.slide4?.rangeSavingsText : this.props.data?.savingsComponent?.slide4?.rangeSavingsText;

        this.attachRangePopUp('rangeV-savings', value, position, label, 'slider-round-savings');

        this.setState({ savingsSliderValue: value });

        this.calcHeight(
            this.state.vestedSliderValue,
            this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment - this.state.vestedSliderValue,
            value,
            this.props.formData.savingsInvestment - value
        )
    }

    handleScroll() {
        let view = this.slide4.current.getBoundingClientRect();
        const Buffer = 5
        if (view.top <= Buffer) this.setState({ visible: true });
        if (this.state.visible && (view.top >= window.innerHeight / 2)) {
            this.props.closeSlide();
        }

        // On certain devices the user is able to scroll up and change the input values without triggering the previous step scroll, mostly long mobile devices
        // On this step it is required to reset the graph
        const inputrect = document.getElementById('savingsBalance').getBoundingClientRect()
        if (this.state.visible && inputrect.top > 0) {
            this.props.closeSlide();
        }
    } 

    getVestedWithdrawValue(amount){
        let table = this.props.formData.leavingReason == 3 ?
            this.props.data?.slide4?.retrenchmentTable
            : this.props.data?.slide4?.retireDismissalTable


        // Calculate tax values on vested
        var taxKeys = Object.keys(table);
        taxKeys = taxKeys.reverse();
        let calcedTaxValue = 0;
        let totalValueRemaining = amount;
        for (var i = 0; i < taxKeys.length; i++) {

            if (totalValueRemaining > taxKeys[i]) {
                let taxableAmount = (totalValueRemaining - parseInt(taxKeys[i]))
                calcedTaxValue = calcedTaxValue + taxableAmount * (table[taxKeys[i]] / 100);
                totalValueRemaining = totalValueRemaining - taxableAmount;
                //break;
            }
        }

        return calcedTaxValue;
    }



    getSavingsTaxValue(amount = 0){

        let salaryValue = this.props.formData.salaryValue;
        let savingsTaxTable = this.props.data?.slide4.individualTaxTable;
        let savingsTaxKeys = Object.keys(savingsTaxTable);
        savingsTaxKeys = savingsTaxKeys.reverse();
        let calcedSavingsTaxValue = 0;
        let totalValueRemaining = salaryValue + amount;

        for (var i = 0; i < savingsTaxKeys.length; i++) {
            if (totalValueRemaining > savingsTaxKeys[i]) {
                let taxableAmount = (totalValueRemaining - parseInt(savingsTaxKeys[i]));
                calcedSavingsTaxValue = calcedSavingsTaxValue + taxableAmount * (savingsTaxTable[savingsTaxKeys[i]] / 100);
                totalValueRemaining = totalValueRemaining - taxableAmount;               
            }
        }

     

        return calcedSavingsTaxValue;
    }   


    handleMaxTax() {

        // calculates max potential tax, on...
        let maxPotentialTaxValue = 0;       

        // calculate max tax on vested
        let investedValue = this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment;
        maxPotentialTaxValue += this.getVestedWithdrawValue(investedValue);     

        // calculate max tax values on savings
        // max tax = tax with full savings amount less tax without savings amount
        maxPotentialTaxValue += this.getSavingsTaxValue(this.props.formData.savingsInvestment) - this.getSavingsTaxValue(0);       

        this.setState({ maxPotentialTaxValue: maxPotentialTaxValue });

    }
    

    calcHeight(vestedWithdrawingValue, vestedRemainingValue, savingsWithdrawingValue, savingsRemainingValue) {

        // calculate tax on vested withdrawal
        let calcedTaxValue = this.getVestedWithdrawValue(vestedWithdrawingValue);

        // calculate tax values on savings withdrawal
        // tax = tax with withdrawal amount less tax without withdrawal amount
        let calcedSavingsTaxValue = this.getSavingsTaxValue(savingsWithdrawingValue) - this.getSavingsTaxValue(0);


        // calculate genderWithdraw
        let genderTable = this.props.data?.slide4?.drawdowns;
        var genderKeys = Object.keys(genderTable);
        var gender = this.props.formData.gender === 0 ? "male" : "female";
        genderKeys = genderKeys.sort().reverse();
        let selectedBracket = null;
        genderKeys.forEach(key => {
            if (selectedBracket == null && this.props.formData.retireAge >= parseInt(key)) {
                selectedBracket = key;
            }
        });

        let yearsInvested = this.props.formData.retireAge - this.props.formData.currentAge;

        // growth on remaining value
        let growth = (vestedRemainingValue + savingsRemainingValue) * Math.pow(1.1, yearsInvested) - (vestedRemainingValue + savingsRemainingValue);

        // max potential future growth
        let maxFutureGrowth = ((this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment + this.props.formData.savingsInvestment) * Math.pow(1.1, yearsInvested)) - (this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment + this.props.formData.savingsInvestment);

        // added: maximum potential monthly value
        let maxPotentialMonthlyIncome = (this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment + this.props.formData.savingsInvestment + maxFutureGrowth) * parseFloat(genderTable[selectedBracket][gender]) * 0.01 / 12;


        // For potential growth result
        let maxTaxableValue = vestedWithdrawingValue + savingsWithdrawingValue + vestedRemainingValue + savingsRemainingValue;

        let output = {

            // withdrawing value (from vested)
            withdrawingValue: vestedWithdrawingValue + savingsWithdrawingValue,

            // tax value on withdrawal amount
            taxValue: calcedTaxValue + calcedSavingsTaxValue,

            // withdrawal amount less tax 
            reciveValue: (vestedWithdrawingValue + savingsWithdrawingValue) - (calcedTaxValue + calcedSavingsTaxValue),

            // total invested less withdrawal amount
            remainingValue: vestedRemainingValue + savingsRemainingValue,

            // monthly income after withdrawal
            monthlyValue: (vestedRemainingValue + savingsRemainingValue + growth) * parseFloat(genderTable[selectedBracket][gender]) * 0.01 / 12,

            // monthy income after withdrawal (in today's money)
            monthlyNegInflation: (((vestedRemainingValue + savingsRemainingValue + growth) * parseFloat(genderTable[selectedBracket][gender]) * 0.01) / 12) / Math.pow(1 + 0.06, yearsInvested),

            // total value after withdrawal
            valueAtRetirement: growth + vestedRemainingValue + savingsRemainingValue,

            // updated: max potential future growth
            maxFutureGrowth: maxFutureGrowth,

            // added: maximum potential monthly value
            maxPotentialMonthlyIncome: maxPotentialMonthlyIncome,


            // For potential growth result   
            growValue: growth,
            growthHeight: ((vestedRemainingValue + savingsRemainingValue) / maxTaxableValue * 100) + "%",
        }


        // potential monthly graph percentage
        output.potentialMonthlyIncomeHeight = (output.monthlyValue / maxPotentialMonthlyIncome * 100) + "%";

        this.setState({
            graphData: output,
            popContent: `<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span>
          <p class='font-size-18 fw-bold text-white mt-0'>Your potential monthly retirement income</p>
          <p class='font-size-16 text-white mb-0 fw-bold'>R${this.addDigitSpaces(output.monthlyValue)}</p>
          <p class='font-size-16 text-white mt-0'>${this.props.journey === 1 ? this.props.data?.slide4.tooltips.potentialIncome : this.props.data?.savingsComponent.slide4.tooltips.potentialIncome}</p>
          <p class='font-size-16 text-white mb-0 fw-bold'>R${this.addDigitSpaces(output.monthlyNegInflation)}</p>
          <p class='font-size-16 text-white mt-0 mb-0'>${this.props.journey === 1 ? this.props.data?.slide4.tooltips.potentialIncomeToday : this.props.data?.savingsComponent.slide4.tooltips.potentialIncomeToday}</p>`
        })
        return (output)
    }

    toggleCollapse() {
        this.setState({ collapseOpen: !this.state.collapseOpen })
    }

    addDigitSpaces(item) {
        let value = parseFloat(item).toFixed(0);
        return value.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
    }

    ctaButtonHandler() {
        const nextSlideIsOpen = document.querySelector('.slide-5') != null
        if (nextSlideIsOpen) {
            this.props.custScrollTo(document.querySelector('.slide-5'))
        } else {
            this.props.openNextSlide()
        }
    }

    render() {
        return (
            <div className="container-fluid container-xxl slide slide-4" ref={this.slide4}>
                <div className="row justify-content-center">
                    <div className="pres-calc-slide__header col-11 col-xl-12">
                        <h2 className="text-red fw-bold font-size-24 font-size-md-32 font-size-xxl-40 text-center cust-mb-26">{ this.props.journey === 1 ? this.props.data?.slide4.title : this.props.data?.savingsComponent.slide4.title}</h2>
                        <div className="font-size-16 font-size-md-16 font-size-xxl-18 text-center fw-light text-grey" dangerouslySetInnerHTML={{ __html: this.props.journey === 1 ? this.props.sanitizeHTML(this.props.data?.slide4.introText)  : this.props.sanitizeHTML(this.props.data?.savingsComponent.slide4.introText) }}>                         
                        </div>
                    </div>
                </div>

                {this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment > 0 &&
                    <div className="row pb-4 cust-mt-neg-1 cust-mt-md-6 justify-content-center slider-styled-row">
                        <div className='col-md-3 d-none d-md-block'></div>
                        <div className="col-12 col-md-6 cust-mt-3 cust-mt-3">
                            <div className="d-flex flex-row justify-content-center align-items-center slider-styled-wrap">
                                <span className="font-size-18 font-size-md-28 text-grey">R0</span>
                                <div className="range-wrap">
                                    <div className="range-value" id="rangeV"></div>
                                    <div className="slider-styled" id="slider-round" ></div>
                                </div>
                                <span className="font-size-18 font-size-md-28 text-nowrap text-grey">R{this.addDigitSpaces(this.props.formData.vestedInvestment + this.props.formData.vestedHarmonisedInvestment)}</span>
                            </div>
                        </div>
                        <div className='slider-styled__info col-md-3'>

                            <a
                                tabIndex={-1}
                                className={'hover-none focus-none'}
                                data-toggle="popover"
                                data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                data-bs-html="true"
                                data-bs-trigger="focus"
                                data-bs-placement="bottom"
                                data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Tax information</p><p class='text-white mb-0'>${this.props.data?.slide4.tooltips.taxInfoVested}</p>`}
                            >
                                <span className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-12 font-size-md-14">Tax information</span>
                                <sup className="fw-light text-dark-grey font-size-14">?</sup>
                            </a>
                        </div>
                    </div>
                }
    
                {(this.props.formData.savingsInvestment > 0 || this.props.formData.formattedSavingsInvestment !== '') &&
                    <div className="row pb-4 cust-mt-neg-1 cust-mt-md-6 justify-content-center slider-styled-row">
                        <div className='col-md-3 d-none d-md-block'></div>
                        <div className="col-12 col-md-6 cust-mt-3">
                            <div className="d-flex flex-row justify-content-center align-items-center slider-styled-wrap">
                                <span className="font-size-18 font-size-md-28 text-grey">R0</span>
                                <div className="range-wrap">
                                    <div className="range-value" id="rangeV-savings"></div>
                                    <div className="slider-styled" id="slider-round-savings" ></div>
                                </div>
                                <span className="font-size-18 font-size-md-28 text-nowrap text-grey">R{this.addDigitSpaces(this.props.formData.savingsInvestment)}</span>
                            </div>
                        </div>
                        <div className='slider-styled__info col-md-3'>


                            {!this.state.savingsAboveMinState && this.props.formData.withdrawalYear === 1 && 
                                <>
                                    {this.props.formData.savingsInvestment !== 0 &&
                                        <div>
                                            <a
                                                tabIndex={-1}
                                                className={'hover-none focus-none'}
                                                data-toggle="popover"
                                                data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                                data-bs-html="true"
                                                data-bs-trigger="focus"
                                                data-bs-placement="bottom"
                                                data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Tax information</p><p class='text-white mb-0'>${this.props.data?.slide4.tooltips.taxInfoSavings}</p>`}
                                            >
                                                <span className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-12 font-size-md-14">Tax information</span>
                                                <sup className="fw-light text-dark-grey font-size-14">?</sup>
                                            </a>
                                        </div>
                                    }
                                    <div>
                                        <a
                                            tabIndex={-1}
                                            className={'hover-none focus-none'}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-trigger="focus"
                                            data-bs-placement="bottom"
                                            data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Why is this slider limited?</p><p class='text-white mb-0'>${this.props.data?.slide4.tooltips.sliderlimitedInfo}</p>`}
                                        >
                                            <span className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-12 font-size-md-14">Why is this slider limited</span>
                                            <sup className="fw-light text-dark-grey font-size-14">?</sup>
                                        </a>
                                    </div>
                                </>

                            }

                            {this.state.savingsAboveMinState && this.props.formData.withdrawalYear === 0 && 

                                <a
                                    tabIndex={-1}
                                    className={'hover-none focus-none'}
                                    data-toggle="popover"
                                    data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                    data-bs-html="true"
                                    data-bs-trigger="focus"
                                    data-bs-placement="bottom"
                                    data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Tax information</p><p class='text-white mb-0'>${this.props.data?.slide4.tooltips.taxInfoSavings}</p>`}
                                >
                                    <span className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-12 font-size-md-14">Tax information</span>
                                    <sup className="fw-light text-dark-grey font-size-14">?</sup>
                                </a>

                            }


                            {this.state.savingsAboveMinState && this.props.formData.withdrawalYear === 1 &&
                                <a
                                    tabIndex={-1}
                                    className={'hover-none focus-none'}
                                    data-toggle="popover"
                                    data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                    data-bs-html="true"
                                    data-bs-trigger="focus"
                                    data-bs-placement="bottom"
                                    data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Why am I unable to withdraw?</p><p class='text-white mb-0'>${this.props.data?.slide4.tooltips.disabledAboveMin}</p>`}
                                >
                                    <span className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-12 font-size-md-14">Why am I unable to withdraw</span>
                                    <sup className="fw-light text-dark-grey font-size-14">?</sup>
                                </a>
                            }

                            {!this.state.savingsAboveMinState && this.props.formData.withdrawalYear === 0 &&

                                <a
                                    tabIndex={-1}
                                    className={'hover-none focus-none'}
                                    data-toggle="popover"
                                    data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                    data-bs-html="true"
                                    data-bs-trigger="focus"
                                    data-bs-placement="bottom"
                                    data-bs-content={`<span class='svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer'></span><p class='font-size-18 fw-bold text-white mt-0'>Why am I unable to withdraw?</p><p class='text-white mb-0'>${this.props.data?.slide4.tooltips.disabledBelowMin}</p>`}
                                >
                                    <span className="form-label cursor-pointer fw-light text-decoration-underline text-dark-grey font-size-12 font-size-md-14">Why am I unable to withdraw</span>
                                    <sup className="fw-light text-dark-grey font-size-14">?</sup>
                                </a>
                            }


                        </div>
                    </div>
                }

                <div className="row cust-mt-1 cust-mt-md-2">

                    <div className='pres-calc-graph col-12'>
                        <div className='pres-calc-graph-investment'>
                            <div className='pres-calc-graph__inner'>
                                <div className='pres-calc-graph__header'>
                                    <p className='font-size-14 font-size-md-18 font-size-lg-22 mb-2'>The total value you have selected to preserve could grow to: <strong className='text-nowrap'>R{this.addDigitSpaces(this.state.graphData.valueAtRetirement)}</strong></p>

                                    {/* potential growth  */}

                                    <p className="font-size-10 font-size-md-12 text-link-blue d-flex text-end align-items-center text-underline cust-mb-md-35 cust-mb-2">
                                        <a 
                                            tabIndex={-1}
                                            className={'hover-none focus-none'}
                                            data-toggle="popover"
                                            data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                            data-bs-html="true"
                                            data-bs-trigger="focus"
                                            data-bs-placement="bottom"
                                            data-bs-content={this.state.popContent}
                                            data-analytics-label="Pres tool link – Monthly retirement income"
                                            data-analytics-action="Link – Clicked"
                                            data-analytics-category="Preservation calculator"
                                            onClick={(e) => { this.props.recordAnalytics(e); }}
                                        >
                                            <u>Your potential monthly retirement income</u>
                                            <sup>?</sup>
                                        </a>
                                    </p>


                                    {/* potential growth  */}                                    
                                    <p className="font-size-12">Remaining invested for your future</p>

                                    {/* potential growth  */}
                                    <p className='font-size-14 font-size-md-18 font-size-lg-24 cust-mb-35 cust-mb-md-2 cust-pr-md-6'>
                                        Potential growth: <strong className='text-nowrap'>R{this.addDigitSpaces(this.state.graphData.growValue)}</strong>
                                    </p>

                                    {/* potential monthly
                                    <p className='font-size-12 font-size-md-14 d-flex align-items-center cust-mb-md-35 cust-mb-2'>The money you keep invested could grow to the value above. This could provide you with the monthly retirement income below in addition to the income you will receive from your retirement component.</p>
                                    */}

                                    {/* potential monthly
                                    <p className='font-size-14 font-size-md-18 font-size-lg-20 cust-mb-35 cust-mb-md-2 cust-pr-md-6'>Potential additional retirement income: <strong className='text-nowrap'>R
                                        {this.addDigitSpaces(this.state.graphData.monthlyValue)}
                                    </strong></p>
                                    */}


                                    <p className='font-size-12 pres-calc-graph__header-max minW-99'>Maximum</p>
                                </div>
                                <div className='pres-calc-graph__barwrapper'>
                                    <p className='font-size-14'><strong>R0</strong></p>
                                    <div className='pres-calc-graph-bar'>

                                        {/* potential growth  */}
                                        <div className='pres-calc-graph-bar-inner' style={{"width" : this.state.graphData.growthHeight, "backgroundColor": "#58595B"}}></div>                                        

                                        {/* potential monthly
                                        <div className='pres-calc-graph-bar-inner'
                                            style={{ "width": this.state.graphData.potentialMonthlyIncomeHeight, "backgroundColor": "#58595B" }}                                            
                                        ></div>
                                        */}
                                    </div>
                                    <p className='font-size-14 minW-99'>
                                        <span className='font-size-12'>
                                            Maximum
                                            <br></br>
                                        </span>
                                        <strong>
                                            {/* potential growth  */}
                                            R{this.addDigitSpaces(this.state.graphData.maxFutureGrowth)}

                                            {/* potential monthly
                                            R{this.addDigitSpaces(this.state.graphData.maxPotentialMonthlyIncome)}
                                            */}
                                        </strong>
                                    </p>
                                </div>
                                <div className='pres-calc-graph__footer'>
                                    <p className='font-size-14'>Amount you keep invested: <strong>R{this.addDigitSpaces(this.state.graphData.remainingValue)}</strong></p>
                                </div>
                            </div>
                        </div>
                        <div className='pres-calc-graph-withdrawal cust-mb-26'>
                            <div className='pres-calc-graph__inner'>
                                <div className='pres-calc-graph__header'>
                                    <p className='font-size-12'>Withdrawing for now</p>
                                    <p className='font-size-14 font-size-md-20 font-size-lg-24 cust-mb-35 cust-mb-md-2 cust-pr-md-6 text-red'>
                                    <a
                                        tabIndex={-1}
                                        className={'hover-none focus-none'}
                                        data-toggle="popover"
                                        data-bs-template="<div class='popover in slide3__popover' role='tooltip'><div class='arrow'></div><h3 class='popover-header'></h3><div class='popover-body p-0'></div></div>"
                                        data-bs-html="true"
                                        data-bs-trigger="focus"
                                        data-bs-placement="bottom"
                                        data-bs-content={`<span class="svgIcon svgIcon--cancel slide3__popover-cancel cursor-pointer"></span><p class="font-size-18 fw-bold text-white mt-0">Tax</p><p class="text-white mb-0">${this.props.journey === 1 ? this.props.data?.slide4.tooltips.taxWithdrawal : this.props.data?.savingsComponent.slide4.tooltips.taxWithdrawal}</p>`}
                                    >
                                        <span className="text-decoration-underline text-red">Tax</span>        
                                        <sup className="font-size-12 font-size-md-14 text-red">?</sup>
                                    </a> you could pay on your withdrawal: <strong className='text-nowrap'>R{this.addDigitSpaces(this.state.graphData.taxValue)}</strong></p>
                                </div>
                                <div className='pres-calc-graph__barwrapper'>
                                    <p className='font-size-14'><strong>R0</strong></p>
                                    <div className='pres-calc-graph-bar' style={{ "backgroundColor": "#FFD1D0" }}>
                                        <div className='pres-calc-graph-bar-inner' style={{ "width": (this.state.graphData.taxValue / this.state.maxPotentialTaxValue) * 100 + '%', "backgroundColor": "#ED0025" }}></div>
                                    </div>
                                    <p className='font-size-14 minW-99'><strong>R{this.addDigitSpaces(this.state.maxPotentialTaxValue)}</strong></p>
                                </div>
                                <div className='pres-calc-graph__footer'>
                                    <p className='font-size-14'>Withdrawal amount after tax: <strong>R{this.addDigitSpaces(this.state.graphData.reciveValue)}</strong></p>
                                </div>
                            </div>
                        </div>
                        <div className='pres-calc-graph__infopop'>
                            <p className="font-size-10 font-size-md-12 text-link-blue text-underline slide-4__copyright">
                                <span data-bs-toggle="modal" data-bs-target="#infoNumbersModal" className="text-decoration-none text-link-blue" role="button"><u>Important information about these numbers</u><sup>?</sup></span>
                            </p>
                        </div>
                        <div id="pop-here" className="pop-here"></div>
                        <div className="row justify-content-center cta-row cust-mt-5">
                            <div className='col-0 col-sm-6'></div>
                            <div className="col-12 col-sm-6">
                                <div className="d-flex justify-content-end">
                                    <button className="btn btn-primary btn-red mb-4 btn--greytext" type="button" onClick={() => this.ctaButtonHandler()}>Find out more about my options</button>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                {/* Info numbers popup modal */}
                <div className="modal" id="infoNumbersModal" tabIndex="-1" aria-labelledby="infoNumbersModalLabel" aria-hidden="true">
                    <div className="modal-dialog modal-dialog-scrollable modal-dialog-centered modal-xl">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h5 className="modal-title font-size-18" id="infoModalLabel">Important information about these numbers</h5>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body font-size-i-12" dangerouslySetInnerHTML={{ __html: this.props.journey === 1 ? this.props.sanitizeHTML(this.props.data?.popUpNumbersText)  : this.props.sanitizeHTML(this.props.data?.savingsComponent.popUpNumbersText) }}></div>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Slide4;

